// extracted by mini-css-extract-plugin
module.exports = {"content":"EventLog_content__1WIEN","value":"EventLog_value__1FZuX","viewAll":"EventLog_viewAll__1Odvp"};